module.exports = __webpack_public_path__ + "img/KM-360AN.f9814438.png";